import { Brain, Clock, ExternalLink, Paperclip, Sparkles } from "lucide-react";

export function PrepPlanSection({ prepPlan, prepLoading, fetchPrepPlan, SOURCE_META, onOpenGmail }) {
  return (
    <section data-testid="event-prep-plan">
      {!prepPlan && !prepLoading && (
        <button
          onClick={fetchPrepPlan}
          disabled={prepLoading}
          className="w-full flex items-center justify-center gap-2 text-sm font-medium px-4 py-3 rounded-xl border border-[color:var(--border)] bg-[color:var(--bg-elevated)] hover:bg-[color:var(--bg-soft)] transition-colors"
          data-testid="event-prep-plan-btn"
        >
          <Brain size={16} className="text-[color:var(--jarvis)]" />
          Skapa lässchema till provet
        </button>
      )}
      {prepLoading && (
        <div className="flex items-center justify-center gap-2 py-3 text-sm text-[color:var(--text-tertiary)]">
          <Sparkles size={14} className="animate-pulse" />
          Edit bygger ditt lässchema…
        </div>
      )}
      {prepPlan?.sessions?.length > 0 && (
        <div data-testid="event-prep-plan-result">
          <div className="flex items-center gap-2 mb-2">
            <Brain size={13} className="text-[color:var(--jarvis)]" />
            <p className="text-[10px] font-semibold uppercase tracking-wider text-[color:var(--jarvis)]">
              Lässchema
            </p>
            <span className="text-[10px] text-[color:var(--text-tertiary)] ml-auto">
              {prepPlan.total_min} min · {prepPlan.days_until_test} dagar kvar
            </span>
          </div>
          {prepPlan.summary && (
            <p className="text-xs text-[color:var(--text-secondary)] mb-3 leading-relaxed">
              {prepPlan.summary}
            </p>
          )}
          <ol className="space-y-2">
            {prepPlan.sessions.map((s, idx) => (
              <li
                key={s.date ? `sess-${s.date}-${idx}` : `sess-${idx}`}
                className="card-soft p-3"
                data-testid={`event-prep-session-${idx}`}
              >
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-[10px] font-semibold uppercase tracking-wider text-[color:var(--text-tertiary)]">
                    {new Date(s.date).toLocaleDateString("sv-SE", { weekday: "short", day: "numeric", month: "short" })}
                  </span>
                  <span className="text-[10px] text-[color:var(--text-tertiary)]">·</span>
                  <span className="text-[10px] text-[color:var(--text-tertiary)] flex items-center gap-1">
                    <Clock size={9} /> {s.duration_min} min
                  </span>
                </div>
                <p className="text-sm leading-snug mb-2">{s.focus}</p>
                {s.evidence_items?.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mt-1">
                    {s.evidence_items.map((it, i) => {
                      const meta = SOURCE_META[it.source] || { Icon: Paperclip };
                      const Icon = meta.Icon;
                      const isGmail = it.source === "gmail";
                      return (
                        <button
                          key={it.message_id || it.url || `ev-${i}-${(it.title || '').slice(0,30)}`}
                          onClick={() => {
                            if (isGmail && it.message_id) onOpenGmail?.(it.message_id);
                            else if (it.url) window.open(it.url, "_blank", "noopener,noreferrer");
                          }}
                          className="inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-md bg-[#EEF2F7] text-[color:var(--jarvis)] hover:bg-[#DEE5EE] transition-colors max-w-full"
                          data-testid={`event-prep-link-${idx}-${i}`}
                        >
                          <Icon size={10} className="flex-shrink-0" />
                          <span className="truncate max-w-[200px]">{it.title || "Material"}</span>
                          <ExternalLink size={9} className="flex-shrink-0 opacity-60" />
                        </button>
                      );
                    })}
                  </div>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </section>
  );
}
